import React from 'react';
const SweepstakesSummaryContext = React.createContext({});
export { SweepstakesSummaryContext };
//# sourceMappingURL=SweepstakesSummary.js.map